// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KoeS","select":"styles_select__1vJQQ"};